module.exports = __webpack_public_path__ + "img/fashion_61.3faca218.jpg";